// extracted by mini-css-extract-plugin
export default {"dateFilter":"tableInvoices_dateFilter__55S6v"};